<template>

</template>

<script>
import Nl2br from 'vue-nl2br';

export default {
  name: "EditSectionSlideBase",
  props: {
    slide: Object,
    totalSlides: Number,
    prefixTextTemplate: String,
    suffixTextTemplate: String
  },
  components: {
    Nl2br
  },
  data: function() {
    return {
      slideBackup: {},
      mode: 'display',
      isImageModalActive: false
    };
  },
  computed: {
    computedPrefixText() {
      return this.processTemplate(this.prefixTextTemplate);
    },
    computedSuffixText() {
      return this.processTemplate(this.suffixTextTemplate);
    },    
    computedSlideText() {
      return `${this.computedPrefixText}${this.slide.editText}${this.computedSuffixText}`;
    },
    characterCount() {
      return this.computedSlideText.length;
    },
    isOverlength() {
      return this.characterCount > 280;
    }
  },
  methods: {
    processTemplate(template) {

      const toReplace = [
        { key: '[slideNum]', value: (this.slide.slideNum + 1).toString() },
        { key: '[totalSlides]', value: this.totalSlides.toString() },
        { key: '\\n', value: '\r\n' }
      ];

      toReplace.forEach(function(element) {
        let regex = new RegExp(this.escapeRegExp(element.key), 'g');
        template = template.replace(regex, element.value);  
      }, this);

      return template;
    },
    switchToEditMode() {
      // Copy current slide to slideBackup, so can undo/cancel the edits
      Object.assign(this.slideBackup, this.slide);
      this.mode = 'edit';
      this.$appInsights.trackEvent('User switched to Edit mode on slide: ' + this.slide.slideNum);
      this.$ga.event('Slide mode', 'edit', 'Create > Edit section', this.slide.slideNum);
    },
    switchToDisplayMode(keepChanges) {
      if (!keepChanges) {
        // Restore slide from slideBackup
        Object.assign(this.slide, this.slideBackup);
      }
      this.mode = 'display';
      this.$appInsights.trackEvent('User switched back to Display mode on slide: ' + this.slide.slideNum, { keepChanges: keepChanges });
      this.$ga.event('Slide mode', 'display', 'Create > Edit section', this.slide.slideNum);
    },
    escapeRegExp(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/create/EditSectionSlideBase.vue